import { useQuery } from '@hooks/reactQuery';

import { getIsVisibleShowHideAssets } from '@api/assets';

import { extractQueryParams } from '@utils/common';

import { IVisibleShowHideAssetsResponse } from '@interfaces/assets/asset';
import { TAssetDetails } from '@interfaces/assets/dto/assetsDTO';
import { TEmptyObject } from '@interfaces/common/common';
import { ISearchValue } from '@interfaces/common/store';

import {
	ASSETS_LIST_SHOW_HIDE_ALL,
	ASSETS_LIST_SHOW_HIDE_FILTER,
} from '@constants/queryKeys';

type TUseQueryIsVisibleShowHideParams = TAssetDetails & ISearchValue & {
	rentStatus?: string | null;
} | TEmptyObject

export const useQueryIsVisibleShowHideAssets = (params: TUseQueryIsVisibleShowHideParams = {}): {
	visibleByFilter?: IVisibleShowHideAssetsResponse;
	visibleOnAll?: IVisibleShowHideAssetsResponse;
} => {
	const {
		searchValue,
		assetTypeId,
		assetSubTypeId,
		contactPersonId,
		isAvailable,
		backhaulAccessibilityStatus,
		assetSiteAvailabilityStatus,
		powerSupplyAvailabilityStatus,
		createdAt,
		updatedAt,
		lastVerificationDate,
		rentStatus,
	} = params;

	const {
		data: visibleByFilter,
	} = useQuery<IVisibleShowHideAssetsResponse>({
		queryKey: [
			ASSETS_LIST_SHOW_HIDE_FILTER,
			{
				searchValue,
				assetTypeId,
				assetSubTypeId,
				contactPersonId,
				isAvailable,
				backhaulAccessibilityStatus,
				assetSiteAvailabilityStatus,
				powerSupplyAvailabilityStatus,
				createdAt,
				updatedAt,
				lastVerificationDate,
				rentStatus,
			},
		],
		queryFn: extractQueryParams(getIsVisibleShowHideAssets),
	});

	const {
		data: visibleOnAll,
	} = useQuery<IVisibleShowHideAssetsResponse>({
		queryKey: [ASSETS_LIST_SHOW_HIDE_ALL],
		queryFn: extractQueryParams(getIsVisibleShowHideAssets),
	});

	return {
		visibleByFilter,
		visibleOnAll,
	};
};
